import React from 'react';
import { PlaceholderProps } from 'react-select';

import { Option } from '../option.model';

export const Placeholder = ({
  children,
  innerProps,
}: PlaceholderProps<Option, true>) => (
  <div className="absolute mx-0.5 text-primary-300" {...innerProps}>
    {children}
  </div>
);
